import React from 'react'
import { ComingSoon } from '../../../Components'

export default function Programs() {
    return (
        <div>
            <ComingSoon />
        </div>
    )
}
